import { BillInfo } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const useFetchPremiumBills = () => {
  const fetchPremiumBills = async () => {
    const res = await medicareApiClient.premiumsApi.getPremiumsBills()
    return res.data
  }

  return useQuery<BillInfo[] | undefined>(
    'premiumBills',
    fetchPremiumBills,
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  )
}
